import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { pipe } from 'ramda';

import { stripHtmlString, inlineEditorHtml } from '../../common/helpers/browser';

const formatHtml = pipe(inlineEditorHtml, stripHtmlString);

const messageTypeMap = {
  sendSms: 'Text',
  sendPush: 'Push',
};

const getNotificationsText = (selected) => {
  if (isEmpty(selected)) return '';
  return Object.keys(selected)
    .filter(key => selected[key])
    .map(key => messageTypeMap[key])
    .join(' & ');
};

const PushNotificationPreview = ({ sendSms, sendPush, subject, text }) => (
  <div>
    <h3 className="c-heading c-heading--tiny u-mb-">
      <span>{getNotificationsText({ sendSms, sendPush })}</span> Notification Preview
      </h3>
    <div className="c-preview-frame">
      <p className="u-type--bold">{formatHtml(subject || '')}</p>
      <p>
        {formatHtml(text || '')} <span className="c-preview-frame__link">http://getsquire.pro/123</span>
      </p>
    </div>
    <p className="u-type--light zeta u-mt--">Directs recipients to web version of email.</p>
  </div>
  );

PushNotificationPreview.propTypes = {
  sendSms: PropTypes.bool,
  sendPush: PropTypes.bool,
  subject: PropTypes.string,
  text: PropTypes.string,
};
PushNotificationPreview.defaultProps = {
  sendSms: false,
  sendPush: false,
  subject: 'Subject line',
  text: 'Message text',
};

export default PushNotificationPreview;
